import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { encryptedStorage } from 'src/utils/storage'

export type SalesPerformance = {
  id: string
  code: string
  name: string
  salesOrderCreated?: number | null
  salesOrderGoodsIssue?: number | null
  salesOrderBilling?: number | null
  salesOrderOpen?: number | null
}

type SalesPerformanceStore = {
  salesPerformances: SalesPerformance[]
  resetSalesPerformances: () => void
  setSalesPerformance: (salesPerformance: SalesPerformance[]) => void
  updateSalesPerformanceStored: (salesPerformance: SalesPerformance) => void
  findSalesPerformanceById: (id: string) => SalesPerformance | undefined
}

export const useSalesPerformanceStore = create<SalesPerformanceStore>()(
  persist(
    (set, get) => ({
      salesPerformances: [],
      resetSalesPerformances: () => set(() => ({ salesPerformances: [] })),
      setSalesPerformance: (salesPerformances: SalesPerformance[]) =>
        set(() => ({ salesPerformances })),
      findSalesPerformanceById: (id: string) => {
        const { salesPerformances } = get()
        return salesPerformances.find(
          (salesPerformance: SalesPerformance) => salesPerformance.id === id
        )
      },
      updateSalesPerformanceStored: (salesPerformance: SalesPerformance) =>
        set((state) => ({
          salesPerformances: state.salesPerformances.map((el) => {
            if (el.id === salesPerformance.id) {
              return salesPerformance
            }
            return el
          }),
        })),
    }),
    {
      name: 'sales-performance-storage',
      storage: encryptedStorage(),
    }
  )
)
